<template>
  <img class="nexia-logo" src="@/assets/nexia-logo-white.png" alt="Nexia" />
</template>

<script>
export default {
  name: "NexiaLogo",
};
</script>

<style scoped lang="scss">
.nexia-logo {
  display: block;
  height: 40px;
  width: auto;
  flex-shrink: 0;
  object-fit: contain;
}
</style>
